import { createAction } from '@ngrx/store';

export default class DigitalActions {
    static readonly ACTION_SCHEMA = '@betslip/digital';

    private static readonly CLOSE_POPUP = `${DigitalActions.ACTION_SCHEMA}/CLOSE_POPUP`;
    private static readonly CLOSE_BETSLIP_TRIGGERED = `${DigitalActions.ACTION_SCHEMA}/CLOSE_BETSLIP_TRIGGERED`;

    static closePopup = createAction(DigitalActions.CLOSE_POPUP);
    // triggered when the close button is clicked, to perform immediate actions that should not wait for animation delays
    static closeBetslipTriggered = createAction(DigitalActions.CLOSE_BETSLIP_TRIGGERED);
}
